/** Merge query updates into existing search params (keeps hub `tab`, etc.). */
export function patchSearchParams(searchParams, updates = {}) {
  const next = new URLSearchParams(searchParams);
  Object.entries(updates).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === 'undefined' || value === 'null') {
      next.delete(key);
    } else {
      next.set(key, String(value));
    }
  });
  return next;
}
